import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { CookieConsentProvider } from '@/contexts/CookieConsentContext'
import '@/i18n'
import '@/index.css'
import App from '@/App'

function I18nLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-200 border-t-primary-600" />
    </div>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Suspense fallback={<I18nLoader />}>
          <CookieConsentProvider>
            <App />
          </CookieConsentProvider>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
)
